module.exports = __webpack_public_path__ + "img/disableupdate.7832d7b2.svg";